import { yupResolver } from "@hookform/resolvers/yup";
import { Rating, Star } from "@smastrom/react-rating";
import CommentController from "components/ReuseableCompos/CommentsForm/CommentController";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import useModal from "customHooks/useModal";
import useUtilities from "customHooks/useUtilities";
import { useColors } from "layout/Layout";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import * as Yup from "yup";

type Props = {
  onSubmit: (data: any) => void;
  close?: () => void;
  textLength?: number;
};

export default function NewFeedbackForm({
  close,
  onSubmit,
  textLength,
}: Props) {
  const { t } = useTranslation("common");
  const { data: utilities } = useUtilities();

  const validationSchema = Yup.object().shape({
    body: Yup.string()
      .min(10, t(`comment_min_invalid`))
      .max(textLength || 250, t(`comment_max_invalid`))
      .required(t(`field_required`)),

    subject: Yup.number().required(t(`field_required`)),

    rating: Yup.number().when("subject", {
      is: (subject) =>
        utilities?.feedback_subjects.find((option) => option.id == subject)
          ?.rateable,
      then: Yup.number().required(t(`field_required`)),
    }),
  });
  const {
    handleSubmit,
    reset,
    setValue,
    control,
    register,
    watch,
    getFieldState,
  } = useForm<{
    body: string;
    subject: number;
    rating?: number;
  }>({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    defaultValues: {
      subject: utilities?.feedback_subjects?.[0].id,
    },
  });
  const modal = useModal();
  const { locale } = useRouter();
  const colors = useColors();

  const onFormSubmit = async (data) => {
    onSubmit(data);
    reset();
    close ? close() : null;
  };

  return (
    <form
      className="needs-validation"
      noValidate
      onSubmit={handleSubmit(onFormSubmit)}
    >
      <div className="">
        <div className={""}>
          <label className="form-label fs-md px-0">{t("subject")}</label>
          <select className="form-select" {...register("subject")}>
            {utilities?.feedback_subjects?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label[locale]}
              </option>
            ))}
          </select>
          <div
            className="invalid-feedback m-0"
            style={{ width: "fit-content" }}
          >
            {getFieldState("subject")?.invalid &&
              getFieldState("subject")?.error?.message}
          </div>
        </div>
        {utilities?.feedback_subjects.find((item) => item?.id == watch("subject"))
          ?.rateable && (
          <>
            <label className="form-label fs-md px-0 mt-3">{t("التقييم")}</label>
  
            <div className="w-100 d-flex justify-content-center align-items-center border-top border-bottom py-3">
              <Rating
                itemStyles={{
                  itemShapes: Star,
                  activeFillColor: colors.primary2,
                  inactiveFillColor: colors.lightTransPrimary,
                  activeBoxBorderColor: "transparent",
                  inactiveBoxBorderColor: "transparent",
                }}
                style={{ maxWidth:260 }}
                value={watch("rating") || 0}
                onChange={(value) => {
                  setValue("rating", value);
                }}
              />
            </div>
            <div
              className="invalid-feedback m-0"
              style={{ width: "fit-content" }}
            >
              {getFieldState("subject")?.error &&
                getFieldState("subject")?.error?.message}
            </div>
          </>
        )}

        <label className="form-label fs-md px-0  mt-3">
          {t("message_label")}
        </label>
        <CommentController
          control={control}
          watch={watch}
          name="body"
          textLength={textLength}
          
          placeholder={
            utilities?.feedback_subjects.find(
              (item) => item?.id == watch("subject") && item?.description
            )?.description?.[locale] ?? t("message_label")
          }
        />
      </div>


      <MolhamButton
        id="support-issue-submit-btn"
        label={t("send")}
        className="w-100"
      />
    </form>
  );
}
